export function updateQuestionAnswerDict(clientStateData, questionAnswerDict, questionKey, answerKey) {
    // Determine the base dictionary to work with.
    const baseDict = clientStateData?.questionAnswerDict || questionAnswerDict || {};
    const existingAnswer = baseDict[questionKey];

    let updatedQuestionAnswerDict;

    if (answerKey === "") {
        if (baseDict.hasOwnProperty(questionKey)) {
            const { [questionKey]: _, ...rest } = baseDict;
            updatedQuestionAnswerDict = rest;
        } else {
            updatedQuestionAnswerDict = baseDict;
        }
    } else if (clientStateData?.questionAnswerDict) {
        if (existingAnswer === undefined) {
            updatedQuestionAnswerDict = { [questionKey]: answerKey, ...baseDict };
        } else if (existingAnswer !== answerKey) {
            updatedQuestionAnswerDict = { ...baseDict, [questionKey]: answerKey };
        } else {
            updatedQuestionAnswerDict = baseDict;
        }
    } else {
        updatedQuestionAnswerDict = { ...questionAnswerDict, [questionKey]: answerKey };
    }

    const updatedClientStateData = {
        ...clientStateData,
        questionAnswerDict: updatedQuestionAnswerDict
    };

    return { updatedQuestionAnswerDict, updatedClientStateData };
}